import React from "react";

const Heading = () => (
  <header className="App-header">
    <span className="hotel-header-title">Mamma Grande Hotel</span>
    <span>
      <i className="fa-solid fa-hotel" />
    </span>
  </header>
);

export default Heading;
